/**
 * Close CookieBot cookie declaration when the ESC key is pressed.
 *
 * This is an accessibility enhancement.
 */
document.addEventListener('keydown', (event) => {
    if (H_Tools.key.isEscape(event)) {
        if (window.Cookiebot && window.Cookiebot.hide) {
            Cookiebot.hide();
        }
    }
});
